import { Injectable } from '@angular/core';
import { from } from 'rxjs';

export type CountryCodeForState = 'CA' | 'US' | 'MX';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor() {}

  getState(country: CountryCodeForState) {
    const apiUrl = './assets/JSON/states/' + country + '-states.json';
    return from(
      fetch(apiUrl).then((response) => {
        return response.json();
      }),
    );
  }
}
